import React from 'react';

const FallIcon = () => (
  <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.8421 7.42857C6.8421 7.74416 7.08717 8 7.38947 8H12.1789C12.6324 8 13 7.61624 13 7.14286V2C13 1.68441 12.7549 1.42857 12.4526 1.42857C12.1503 1.42857 11.9053 1.68441 11.9053 2V6.10282L7.54298 1.90832C7.21909 1.59689 6.71753 1.60764 6.40617 1.93269L4.51579 3.90616L0.934416 0.167367C0.720656 -0.0557899 0.374081 -0.0557899 0.160321 0.167367C-0.0534402 0.390524 -0.0534402 0.752333 0.160321 0.975489L3.93522 4.91632C4.25586 5.25105 4.77572 5.25105 5.09636 4.91632L6.99453 2.93471L11.0739 6.85714H7.38947C7.08717 6.85714 6.8421 7.11298 6.8421 7.42857Z"
      fill="currentColor"
    />
  </svg>
);

export default FallIcon;
